import React, { FC, useContext } from 'react'
import Image from '../../common/Image/Image'
import css from './QuizCardPicture.module.scss'
import QuestionIcon from '../../../public/static/icons/quiz/question.svg'
import { IQuestionVariant } from '../../types'
import { QuizContext } from '../../../contexts/quizProvider'
import cx from 'classnames'

const QuizCardPicture: FC<{ variant: IQuestionVariant }> = ({ variant }) => {
  const { step, setStep, setFinal, setQuizAnswers } = useContext(QuizContext)
  return (
    <li className={css.outer}>
      <div
        className={css.wrapper}
        onClick={() => {
          if (step < 4) {
            setQuizAnswers((prev) => {
              prev.push(variant.id)
              return prev
            })
            setStep((prev) => ++prev)
          } else {
            setQuizAnswers((prev) => {
              prev.push(variant.id)
              return prev
            })
            setFinal(true)
          }
        }}
      >
        <div
          className={cx(
            css.picture_wrapper,
            (step === 3 || step === 4) && css.small,
          )}
        >
          {variant.img && (
            <figure className={css.image}>
              <Image
                key={`${variant.id}`}
                layout="fill"
                src={variant.img}
                alt={variant.title}
              />
            </figure>
          )}
        </div>

        <div className={css.text}>
          {variant.title && (
            <div className={css.title_wrapper}>
              <p className={css.title}>{variant.title}</p>
              {variant.tooltip && (
                <div className={css.tooltip_wrapper}>
                  <QuestionIcon />

                  <p className={css.tooltip}>{variant.tooltip}</p>
                </div>
              )}
            </div>
          )}

          <p className={css.description}>{variant.description}</p>
        </div>
      </div>

      {variant.tooltip && (
        <div className={css.tooltip_wrapper_mobile}>
          <QuestionIcon />

          <p className={css.tooltip}>{variant.tooltip}</p>
        </div>
      )}
    </li>
  )
}

export default QuizCardPicture
